module.exports = __webpack_public_path__ + "img/i16.b4e280a8.png";